import { render, staticRenderFns } from "./DashboardTabDetalhes.vue?vue&type=template&id=8d67167c"
import script from "./DashboardTabDetalhes.vue?vue&type=script&lang=js"
export * from "./DashboardTabDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports